module.exports = __webpack_public_path__ + "static/media/logo-cnes-landscape-1.f065e2cd.svg";